import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({ changeDetection: ChangeDetectionStrategy.Eager,
 templateUrl: './page-not-found.component.html' })

export class PageNotFoundComponent implements OnInit {

    constructor(private router: Router, private route: ActivatedRoute) { }

    ngOnInit(): void {
        this.route.url.subscribe(e => {
            console.log(e);
        });
    }
}
